import { ApplicationRef } from '@angular/core';
import { getWindow } from 'src/vendor/window/window';

export function getAppAPI() {
    const w: any = getWindow();
    w.IHD = w.IHD || {};
    w.IHD.api = w.IHD.api || {};
    return w.IHD.api;
}

export class AppGlobal {
    static setInjector(injector) {
        const appAPI: any = getAppAPI();
        appAPI.injector = injector;
    }

    static injector(): any {
        const w: any = window as any;
        return w.IHD && w.IHD.api && w.IHD.api.injector;
    }

    static setRef(appRef: ApplicationRef) {
        const appAPI: any = getAppAPI();
        appAPI.appRef = appRef;
    }

    static appRef(): ApplicationRef {
        const appAPI: any = getAppAPI();
        return appAPI && appAPI.appRef;
    }
}